import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../lib/firebase";
import { EMPTY_PLAYER_STATS, normalizePlayerStats, type PlayerStats } from "../types/stats";

export function usePlayerStats(uid: string | undefined): {
  stats: PlayerStats;
  loading: boolean;
  error: string | null;
} {
  const [stats, setStats] = useState<PlayerStats>(EMPTY_PLAYER_STATS);
  const [loading, setLoading] = useState(!!uid);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!uid) {
      setStats(EMPTY_PLAYER_STATS);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    const ref = doc(db, "stats", uid);
    const unsub = onSnapshot(
      ref,
      snap => {
        setStats(normalizePlayerStats(snap.exists() ? (snap.data() as Partial<PlayerStats>) : null));
        setLoading(false);
        setError(null);
      },
      err => {
        console.error("stats listen failed", err);
        setError("Couldn't load your stats.");
        setLoading(false);
      },
    );
    return () => unsub();
  }, [uid]);

  return { stats, loading, error };
}
